import { track } from './analytics'

/**
 * TELEFON- ES E-MAIL-KATTINTASOK MERESE.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT EGY FIGYELO, ES NEM `onClick` MINDEN LINKEN
 *
 * `tel:` es `mailto:` hivatkozas ma OT helyen van: lablec, mobil
 * fejlecmenu, oldalsav, a hibahatar tartalek kepernyoje es a
 * rendeleskovetes. Ha mindegyikbe kezzel kerulne a meres, a hatodik
 * helyrol - amit majd valaki kesobb ir - biztosan lemaradna, es a
 * hianyt semmi nem jelezné: a szam egyszeruen kisebb lenne.
 *
 * Egy dokumentumszintu figyelo ezt kizarja. Ami `tel:` vagy `mailto:`,
 * az merve van, barhol keletkezik.
 *
 * ────────────────────────────────────────────────────────────────────
 * MIERT A LEFELE HALADO SZAKASZBAN (capture)
 *
 * Az oldal tobb helyen elkapja a kattintast (menu bezarasa,
 * utvonalvaltas), es egy `stopPropagation` a felszallo szakaszban
 * eltuntetne elolunk az esemenyt. A lefele halado szakaszban mi vagyunk
 * elobb - a meres nem fugghet attol, hogy egy kesobbi kezelo mit tesz.
 *
 * A MUKODEST NEM ERINTJUK: nem hivunk `preventDefault`-ot, a hivas es a
 * levelezoprogram ugyanugy nyilik, mint eddig.
 * ────────────────────────────────────────────────────────────────────
 */

type Fajta = 'telefon' | 'email'

function fajta(href: string): Fajta | null {
  const cim = href.trim().toLowerCase()
  if (cim.startsWith('tel:')) return 'telefon'
  if (cim.startsWith('mailto:')) return 'email'
  return null
}

function kattintas(esemeny: MouseEvent): void {
  /*
    CSAK A SIMA BAL GOMB. A kozepso gomb, a Ctrl/Cmd-kattintas es a
    jobb gomb nem kapcsolatfelvetel - uj fül vagy menu nyilik toluk.
  */
  if (esemeny.button !== 0) return
  if (esemeny.metaKey || esemeny.ctrlKey || esemeny.shiftKey || esemeny.altKey) return

  const cel = esemeny.target
  if (!(cel instanceof Element)) return

  const link = cel.closest('a[href]')
  if (!(link instanceof HTMLAnchorElement)) return

  /*
    A `getAttribute` az EREDETI erteket adja. A `link.href` ehelyett a
    bongeszo altal feloldott, abszolut alakot adna vissza - ott a
    `mailto:` es a `tel:` felismerese mar bizonytalanabb.
  */
  const f = fajta(link.getAttribute('href') ?? '')
  if (!f) return

  /*
    A SZAM ES A CIM NEM MEGY EL. Csak a fajta - `telefon` vagy `email` -,
    es hogy a lap melyik reszerol indult. A `sanitise` amugy is kiszurne
    minden `phone`/`email` nevu kulcsot; itt fel sem vesszuk oket.
  */
  track('contact_clicked', { kind: f, place: hely(link) })
}

/**
 * HONNAN INDULT A KATTINTAS.
 *
 * Nem a pontos komponensnev erdekel, hanem hogy melyik feluleti elemrol:
 * ebbol derul ki, erdemes-e tobb helyre kitenni a telefonszamot.
 */
function hely(link: HTMLAnchorElement): string {
  if (link.closest('.footer')) return 'lablec'
  if (link.closest('.header-menu, .header')) return 'fejlec'
  if (link.closest('.estimate-side')) return 'oldalsav'
  if (link.closest('.track')) return 'rendeleskovetes'
  if (link.closest('.error-boundary')) return 'hibakepernyo'
  return 'egyeb'
}

let bekotve = false

/** Bekotes. Tobbszor is hivhato: masodszorra nem csinal semmit. */
export function kapcsolatiKattintasokFigyelese(): () => void {
  if (bekotve) return () => undefined
  bekotve = true

  document.addEventListener('click', kattintas, true)

  return () => {
    document.removeEventListener('click', kattintas, true)
    bekotve = false
  }
}
